import { useCallback } from 'react';

import type {
	EMBEDDED_CONFLUENCE_METRICS_PREFIX,
	EMBEDDED_VIEW_TTI,
	EMBEDDED_EDITOR_TTI,
	EMBEDDED_EDIT_CLICK,
	EMBEDDED_IFRAME_CONTENT_INITIALIZED,
} from '../performance-metrics/constants';

export type MessageType =
	| `${typeof EMBEDDED_CONFLUENCE_METRICS_PREFIX}${typeof EMBEDDED_VIEW_TTI}`
	| `${typeof EMBEDDED_CONFLUENCE_METRICS_PREFIX}${typeof EMBEDDED_EDITOR_TTI}`
	| `${typeof EMBEDDED_CONFLUENCE_METRICS_PREFIX}${typeof EMBEDDED_EDIT_CLICK}`
	| `${typeof EMBEDDED_CONFLUENCE_METRICS_PREFIX}${typeof EMBEDDED_IFRAME_CONTENT_INITIALIZED}`;

type EventMarker = {
	timestamp: number;
	metadata?: Record<string, any>;
};

export const useEmbeddedConfluenceEventMarkers = () => {
	return useCallback((payload: EventMarker, type: MessageType) => {
		window.parent.postMessage({ type, payload }, '*');
	}, []);
};
